'use client';

import { Suspense } from 'react';
import useAppContextSidebar from './use-app-context-sidebar';
import { CloseButton } from '@/lib/components/close-button/CloseButton';
import { LoadingOverlay } from '@repo/commons-ui';

export default function AppContextSidebar() {
  const { isOpen, content, width, setIsOpen } = useAppContextSidebar();

  return (
    <Suspense fallback={<LoadingOverlay />}>
      <div
        className='flex flex-col  h-screen shadow-lg transition-all duration-300 ease-in-out bg-sidebar text-sidebar-foreground overflow-hidden border-l border-sidebar-border'
        style={{ width: isOpen ? width : '0px', maxWidth: width }}
      >
        {
          <div className='flex border-b border-gray-200 bg-sidebar'>
            <div className='flex grow'>{content.title}</div>
            {content.showCloseButton && (
              <div className='p-4'>
                <CloseButton onClick={() => setIsOpen(false)} />
              </div>
            )}
          </div>
        }

        <div className='flex grow p-6 overflow-y-auto bg-sidebar'>{content.content}</div>

        {content.footer && <div className='flex p-6 border-t border-gray-200 bg-sidebar'>{content.footer}</div>}
      </div>
    </Suspense>
  );
}
